import { AnalyticsAction, AnalyticsActionSubject } from '../../types';
import { BaseInvitePeopleAnalytics } from '../../analytics';

export class InfiSpotlightAnalytics extends BaseInvitePeopleAnalytics {
	spotlightViewed(): void {
		this.fireScreen({
			name: AnalyticsActionSubject.INFI_SPOTLIGHT,
		});
	}

	spotlightDismissed(): void {
		this.fireTrack({
			actionSubject: AnalyticsActionSubject.INFI_SPOTLIGHT,
			action: AnalyticsAction.CLOSED,
		});
	}
}
